var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canShow('create'))?_c('va-action-button',{attrs:{"hide-label":_vm.icon,"label":_vm.$t('va.actions.create'),"icon":"mdi-plus","color":_vm.color || 'success',"text":"","to":_vm.getRoute('create')},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }